import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgStarFull = function SvgStarFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3607 2.85441C12.8131 1.71454 11.1866 1.71455 10.6389 2.85441L8.27035 7.78438C8.27035 7.78438 8.26756 7.78818 8.26314 7.78876L2.81352 8.50223C1.55773 8.66664 1.04567 10.2152 1.97337 11.0898L5.9575 14.8461C5.95929 14.8478 5.95913 14.8497 5.95913 14.8497L4.95857 20.2164C4.72511 21.4686 6.05037 22.4147 7.15961 21.8167L11.9942 19.2106C11.9976 19.2088 12.002 19.2088 12.0054 19.2106L16.84 21.8167C17.9493 22.4147 19.2745 21.4686 19.0411 20.2164L18.0405 14.8497C18.0405 14.8497 18.0403 14.8478 18.0421 14.8461L22.0263 11.0898C22.954 10.2152 22.4419 8.66664 21.1861 8.50223L15.7365 7.78876C15.7321 7.78818 15.7293 7.78438 15.7293 7.78438L13.3607 2.85441Z"
  })));
};

export { SvgStarFull as ReactComponent };
//# sourceMappingURL=star-full.svg.js.map
